import React, { useCallback, useEffect, useState } from 'react';
import { Table, Icon, Spin, message } from 'antd';

import { XHT_ICON_LIGHT } from '../../config/media';
import { getStakeAll, getPublicCollateral, getCollateral } from '../../common/fetch';
import Collateralize from '../../components/Collateralize';
import { StakedXHTContainer } from './style';
import Pledge from '../../components/Pledge/Pledge';
import { Link } from 'react-router-dom';
import { getRemovalColumns } from '../../components/CollateralStatus/Utils'

const getStakedColumns = (history = {}, stakeData = {}, handleAdd, handleRemove, exchange) => {
	return [
		{
			title: 'Name',
			key: 'name',
			render: (item) => (
				<div className="name-column">
					{exchange.id === item.exchange_id
						?
						<Icon type="star" />
						: null
					}{' '}
					{item.Exchange.name}
					{exchange.id === item.exchange_id
						?
						<span>(your project)</span>
						: null
					}{' '}
					(<Link to={`/project/${item.exchange_id}`}>View</Link>)
				</div>
			)
		},
		{
			title: 'Total staked (XHT)',
			key: 'total_stake',
			render: (item) => <div>{item.amount}</div>
		},
		{
			title: 'Total earnt (XHT)',
			key: 'total_earnt',
			render: (item) => <div>{item.earning}</div>
		},
		{
			title: 'Add stake',
			key: 'add_stake',
			render: (item) => <span className="anchor" onClick={() => handleAdd(item)}>Add</span>
		},
		{
			title: 'Remove stake',
			key: 'remove_stake',
			render: (item) => <span className="anchor" onClick={() => handleRemove(item)}>Remove</span>
		}
	];
};

const StakedXHT = ({ history = {}, collateral, exchange, user, updateCollateral, actions }) => {
	const [stakedData, setStakedData] = useState([]);
	const [resData, setResData] = useState({});
	const [isOpen, setOpen] = useState(false);
	const [type, setType] = useState('')
	const [isLoading, setLoading] = useState(true);
	const [stakeLoading, setStakeLoading] = useState(false);
	const [removeLoading, setRemoveLoading] = useState(false);
	const [selectedStake, setSelected] = useState('');
	const [collateralData, setCollateral] = useState({});
	const [removalData, setRemovalData] = useState({});
	const [cancelData, setCancelData] = useState({});

	const getStakeAllData = useCallback(async () => {
		try {
			const res = await getStakeAll();
			setResData(res.data);
			updateCollateral({ pledgesAll: res.data });
			const allStakedData = [...res.data.pledges];
			setStakedData(allStakedData);
			setLoading(false)
		} catch (error) {
			setLoading(false)
		}
	}, [updateCollateral]);

	useEffect(() => {
		getStakeAllData();
	}, [getStakeAllData]);

	const getData = useCallback(async () => {
		if (selectedStake) {
			let res = {};
			if (user.id === 0) {
				try {
					res = await getPublicCollateral(selectedStake);
				} catch (error) {
					message.error('Failed to get stake project Data.');
				}
			} else {
				try {
					res = await getCollateral(selectedStake);
				} catch (error) {
					message.error('Failed to get stake project Data.');
				}
			}
			const { data = {} } = res;
			actions.setCollateral(data);
			setCollateral(data);
			setRemoveLoading(false);
			setStakeLoading(false);
		}
	}, [selectedStake, user, actions]);

	useEffect(() => {
		getData();
	}, [getData]);

	const handleStoreCallback = () => {
		getData();
		getStakeAllData();
	};

	const removedData = stakedData.filter(data => data.close_request !== null)
	const filterData = stakedData.filter(data => data.close_request === null)
	let total = 0;
	removedData.forEach(record => {
		total += record.amount;
	});

	const handleAdd = (item) => {
		setOpen(true);
		setType("collateralize");
		if (selectedStake !== item.exchange_id) {
			setSelected(item.exchange_id);
			setStakeLoading(true);
		}
	};

	const handleRemove = (item) => {
		setOpen(true);
		setType("remove");
		setRemovalData(item);
		if (selectedStake !== item.exchange_id) {
			setSelected(item.exchange_id);
			setStakeLoading(true);
		}
	};

	const handleCancelRemove = (item) => {
		setOpen(true);
		setType("cancel-remove");
		setCancelData(item);
		if (selectedStake !== item.exchange_id) {
			setSelected(item.exchange_id);
			setRemoveLoading(true);
		}
	};

	const onCancel = () => {
		setOpen(false);
		setType("");
		if (type === "remove") {
			history.push("/collateral")
		}
	}
	if (isLoading) {
		return <Spin />
	}

	return (
		<StakedXHTContainer>
			<div className='d-flex'>
				<img src={XHT_ICON_LIGHT} className='xht-icon' alt='xht-icon' />
				<div className='title'>XHT staked as Collateral</div>
			</div>
			<div className='sub-content'>
				<div className='sub-title-wrapper'>
					<div className='sub-title'>Projects staked</div>
					<div>
						Projects that you've staked XHT collateral on and their
						earnings.
					</div>
				</div>
				<div className='table-container'>
					<Table
						loading={stakeLoading}
						columns={getStakedColumns(history, resData, handleAdd, handleRemove, exchange)}
						dataSource={filterData ? filterData : stakedData}
						rowKey={(data) => {
							return data.id;
						}}
						pagination={false}
					/>
				</div>
				<div className='total-wrapper'>
					<div className='box'>
						<div className='sub-title'>Total staked in all projects</div>
						<div className='black-txt'>
							<span>Total staked</span>:{' '}
							{resData.totalAmount}{' '}
							XHT
						</div>
					</div>
					<div className='box box-align d-flex'>
						<img
							src={XHT_ICON_LIGHT}
							className='xht-icon-large'
							alt='xht-icon'
						/>
						<div>
							<div className='sub-title'>Total earnings</div>
							<div className='black-txt'>
								<span>Total earnt from staking</span>:{' '}
								{resData.totalEarning}{' '}
								XHT
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className='sub-content'>
				<div className='sub-title-wrapper'>
					<div className='sub-title'>Stake in removal process</div>
					<div>
						Unstaking takes time and any amount being removed will stop
						all earnings.
					</div>
				</div>
				<div className='table-container'>
					<Table
						loading={removeLoading}
						columns={getRemovalColumns(handleCancelRemove, true, exchange)}
						dataSource={removedData.length ? removedData : null}
						rowKey={(data) => {
							return data.id;
						}}
						pagination={false}
					/>
				</div>
				<div className='d-flex'>
					<div className='box'>
						<div className='sub-title'>
							Total stake in removal process
						</div>
						<div className='black-txt'>
							<span>Total in process:</span> {total} XHT
						</div>
					</div>
				</div>
			</div>
			{type === "collateralize"
				?
				<Collateralize
					visible={isOpen && !stakeLoading}
					exchange={exchange}
					collateral={collateralData}
					onCancel={onCancel}
					onCollateralCallback={handleStoreCallback}
				/>
				:
				<Pledge
					visible={isOpen && !stakeLoading && !removeLoading}
					user={user}
					exchange={exchange}
					collateral={collateralData}
					amount={removalData.amount}
					type={type}
					cancelData={cancelData}
					getStakeAllData={getStakeAllData}
					onCancel={onCancel}
					history={history}
					removedData={removedData}
				/>
			}
		</StakedXHTContainer>
	);
};

export default StakedXHT;
